<template>
  <div class="d-flex align-center">
    <!-- SELECT BUTTON -->
    <div style="width: 180px">
      <!-- :menu-props="{ height: 900 }" -->
      <app-select
        v-bind="$attrs"
       
        placeholder="리액션 선택"
        :items="filteredInstructions"
        item-value="id"
        :item-text="getItemLabel"
        :value="value"
        @change="onChange"
      ></app-select>
      <!-- prepend-inner-icon="mdi-run-fast" -->
    </div>

    <!-- PLAY BUTTON -->
    <div v-if="!hidePlay">
      <play-button class="ml-1 mr-1" @click="onClickPlay"></play-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String,
    filterTags: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value(newValue) {
      this.selectedInstructionId = newValue;
    },
  },
  created() {
    this.selectedInstructionId = this.value;
  },
  data() {
    return {
      selectedInstructionId: null,
    };
  },
  methods: {
    onChange(value) {
      this.$emit("change", value);
      this.selectedInstructionId = value; // 필요가 있다 v-model이 선언되지 않았으면
    },
    onClickPlay() {
      this.$emit("play", this.selectedInstructionId);
    },
    getItemLabel(item) {
      return item.label || item.id;
    },
  },
  computed: {
    // @duplicate TheBottomControlPanel
    ...mapState(["reactions"]),
    allInstructions() {
      // reaction 테이블(system + 내것). 셀렉터엔 숨김(is_hide) 제외.
      return this.reactions.list
        .filter((r) => !r.isHide)
        .map((r) => ({ id: r.id, label: r.label, tags: r.tags || [] }));
    },
    filteredInstructions() {
      // tag가 array인 경우
      return this.allInstructions.filter((i) => {
        if (!this.filterTags) return true;
        if (this.filterTags.length === 0) return true;

        const tags = i.tags || [];
        const result = tags.some((tag) => this.filterTags.includes(tag));
        return result;
      });
    },
    hidePlay() {
      if (this.$attrs["hide-play"] === undefined) return false;

      return true;
    },
  },
};
</script>

<style scoped>
/* 셀렉트 높이/톤은 AppSelect(height prop · 다크/라이트)로 이관됨 */
</style>
